import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const navLinks = [
 
  { label: 'Descubrí', href: '#descubri' },
  { label: 'Recorré', href: '#recorre' },
  { label: 'Galería', href: '#galeria' },
];

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const y = window.scrollY || 0;
      const doc = document.documentElement;
      const max = Math.max(1, (doc.scrollHeight || 1) - (window.innerHeight || 1));
      setProgress(Math.max(0, Math.min(1, y / max)));
    };

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        borderBottom: 1,
        borderColor: 'divider',
        background: '#fff',
        paddingTop: 'env(safe-area-inset-top, 0px)',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 64 }}>
        {/* Logos */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
          <Box
            component="img"
            src="/images/IMG_7623.PNG"
            alt="Municipalidad de La Granja"
            sx={{
              height: { xs: 40, md: 50 },
              width: 'auto',
              objectFit: 'contain',
            }}
          />
          <Box
            component="img"
            src="/images/IMG_4799 (2).PNG"
            alt="Turismo Cultura Deporte La Granja"
            sx={{
              height: { xs: 40, md: 50 },
              width: 'auto',
              objectFit: 'contain',
            }}
          />
          <Box
            component="img"
            src="/images/IMG_2826.PNG"
            alt="Sierras Chicas"
            sx={{
              height: { xs: 40, md: 50 },
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
        {/* Links desktop */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
          {navLinks.map(link => (
            <Link
              key={link.label}
              href={link.href}
              underline="none"
              className="nav-link"
              sx={{
                color: '#1d365a',
                fontWeight: 600,
                mx: 1,
                position: 'relative',
                '&:hover': { color: '#f0961f' },
              }}
            >
              {link.label}
            </Link>
          ))}
          <Box sx={{ ml: 2, display: 'flex', gap: 1 }}>
            <IconButton
              size="small"
              color="inherit"
              component="a"
              href="https://www.instagram.com/turismo.lagranja/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-pop"
            >
              <InstagramIcon sx={{ color: '#1d365a' }} />
            </IconButton>
            <IconButton 
              size="small"
              color="inherit"
               component="a"
              href="https://www.facebook.com/profile.php?id=61554349030835&locale=es_LA"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-pop"
            >
              <FacebookIcon sx={{ color: '#1d365a' }} />
            </IconButton>
          </Box>
        </Box>
        {/* Mobile menu button */}
        <IconButton edge="end" color="inherit" aria-label="menu" sx={{ display: { md: 'none' } }} onClick={() => setDrawerOpen(true)}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
      {/* Progress line */}
      <Box
        aria-hidden="true"
        sx={{
          height: 2,
          width: '100%',
          background: 'rgba(29,54,90,0.08)',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: `${Math.round(progress * 100)}%`,
            background: 'linear-gradient(90deg, #f0961f, #1976d2)',
            transition: 'width 120ms linear',
          }}
        />
      </Box>
      {/* Drawer mobile */}
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 250, p: 2 }} role="presentation" onClick={() => setDrawerOpen(false)}>
          <Typography variant="h6" sx={{ mb: 2, color: '#1d365a', fontWeight: 700 }}>Menú</Typography>
          <List>
            {navLinks.map(link => (
              <ListItem button component="a" href={link.href} key={link.label}>
                <ListItemText primary={link.label} />
              </ListItem>
            ))}
          </List>
          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            <IconButton
              size="small"
              color="inherit"
              component="a"
              href="https://www.instagram.com/turismo.lagranja/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-pop"
            >
              <InstagramIcon sx={{ color: '#1d365a' }} />
            </IconButton>
            <IconButton 
              size="small"
              color="inherit"
               component="a"
              href="https://www.facebook.com/profile.php?id=61554349030835&locale=es_LA"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-pop"
            >
              <FacebookIcon sx={{ color: '#1d365a' }} />
            </IconButton>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
} 